<template>
  <el-card>
    <el-form v-if="isDesktop" size="default" :inline="true">
      <div class="filter-header">
        <h3>Filters</h3>
        <el-button
          class="filter-reset-button el-tag el-tag--danger"
          icon="RefreshElementIcon"
          size="small"
          @click="reset"
        >
          Reset
        </el-button>
      </div>
      <el-form-item>
        <AdTypeSelect
          v-model="filter.type_id"
          :with-empty="true"
          label="Ad Type"
          @update:modelValue="update"
        />
      </el-form-item>
      <el-form-item>
        <ProtocolSelect
          v-model="filter.protocol"
          label="Protocol"
          @update:modelValue="update"
        />
      </el-form-item>
      <el-form-item>
        <StreamSelect
          v-model="filter.stream"
          label="Stream"
          @update:modelValue="update"
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="filter.name"
          class="filter-item"
          placeholder="Search by name or ID"
          @keyup.enter="update"
        />
      </el-form-item>
      <el-form-item class="filter-item">
        <FeedStateSelector
          v-model="filter.state"
          placeholder="State"
          @update:modelValue="update"
        />
      </el-form-item>
    </el-form>
    <el-form v-else class="mobile" label-position="left" label="Filters">
      <div class="filter-header">
        <h3>Filters</h3>
        <el-button
          class="filter-reset-button el-tag el-tag--danger"
          icon="RefreshElementIcon"
          size="small"
          @click="reset"
        >
          Reset
        </el-button>
      </div>
      <el-form-item class="mb-1 mt-1">
        <el-input
          v-model="filter.name"
          placeholder="Search by name or ID"
          @keyup.enter="update"
        />
      </el-form-item>
      <el-form-item class="mb-1">
        <AdTypeSelect
          v-model="filter.type_id"
          :with-empty="true"
          label="Ad Type"
          @update:modelValue="update"
        />
      </el-form-item>
      <el-form-item class="mb-1">
        <ProtocolSelect
          v-model="filter.protocol"
          label="Protocol"
          @update:modelValue="update"
        />
      </el-form-item>
      <el-form-item class="mb-1">
        <StreamSelect
          v-model="filter.stream"
          label="Stream"
          @update:modelValue="update"
        />
      </el-form-item>
      <el-form-item class="mb-1">
        <FeedStateSelector
          v-model="filter.state"
          placeholder="State"
          @update:modelValue="update"
        />
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import AdTypeSelect from '@/components/Select/AdTypeSelect.vue'
import ProtocolSelect from '@/components/Select/ProtocolSelect.vue'
import useResize from '@/hooks/useResize'
import StreamSelect from '@/components/Select/StreamSelect.vue'
import FeedStateSelector from '../../components/FeedStateSelector.vue'

export default defineComponent({
  name: 'FilterForm',
  components: {
    AdTypeSelect,
    StreamSelect,
    ProtocolSelect,
    FeedStateSelector
  },
  props: {
    modelValue: {
      type: Object,
      default: () => {}
    },
    resetValue: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const { isDesktop } = useResize()
    const filter = ref({ ...props.modelValue })

    const update = () => {
      context.emit('update:modelValue', { ...filter.value })
      context.emit('update', {})
    }

    const reset = () => {
      filter.value = JSON.parse(JSON.stringify(props.resetValue))
      update()
    }

    watch(
      (_: any) => props.modelValue,
      (newFilter: any) => {
        filter.value = newFilter
      }
    )

    return {
      update,
      reset,
      filter,
      isDesktop
    }
  }
})
</script>

<style lang="scss" scoped>
.el-form--inline {
  .el-form-item {
    .el-input,
    .el-cascader,
    .el-select,
    .el-autocomplete {
      width: 160px;
    }
  }
}

.el-form--inline {
  .el-form-item {
    margin-right: 20px;
  }
}

.mobile {
  .el-select {
    width: 100%;
  }
}
.filter-container {
  margin-top: 1em;
}

.filter-header {
  display: flex;
  align-items: center;
  gap: 12px;

  h3 {
    margin-right: 4px;
  }
}

.filter-reset-button {
  cursor: pointer;
}

@media (max-width: 550px) {
  button {
    width: 100%;
  }

  .filter-header {
    button {
      width: auto;
    }
  }
}
</style>
